const breakpoints = {
  breakpointMobile: '576px',
};

export default breakpoints;
